import React from 'react'

export interface IconProps {
    width?: string | number;
    height?: string | number;
    className?: string;
}

export default function AccountSettingsIcon({
    width = 100,
    height = 100,
    className = '',
}: IconProps) {
    return (
        <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 124.000000 109.000000"
            preserveAspectRatio="xMidYMid meet"
            className={`cursor-pointer group-hover:stroke-white transition duration-200 ${className}`}
        >
            <g transform="translate(0.000000,109.000000) scale(0.100000,-0.100000)" fill="#fff" stroke="none">
                <path d="M547 952 c-10 -10 -17 -26 -17 -36 0 -10 -17 -24 -46 -36 -50 -22 -80 -25 -89 -10 -13 21 -52 9 -88 -28 -39 -40 -45 -65 -23 -95 22 -29 -18 -112 -64 -135 -33 -16 -35 -21 -38 -71 -3 -58 15 -91 50 -91 13 0 26 -16 42 -52 21 -47 22 -56 10 -75 -22 -35 -17 -56 24 -96 37 -36 74 -48 87 -27 16 26 135 -16 135 -48 0 -33 32 -52 87 -52 53 0 83 20 83 54 0 10 17 24 46 36 50 22 80 25 89 10 13 -21 52 -9 88 28 40 41 45 60 23 95 -12 19 -11 28 10 75 16 36 29 52 42 52 35 0 53 33 50 91 -3 50 -5 55 -38 71 -46 23 -86 106 -64 135 23 30 16 57 -24 96 -37 36 -74 48 -87 27 -16 -26 -135 16 -135 48 0 33 -32 52 -87 52 -36 0 -55 -5 -66 -18z m101 -11 c7 -4 21 -23 30 -41 13 -25 30 -38 71 -53 47 -17 58 -18 93 -6 37 12 40 11 65 -14 25 -25 26 -28 14 -65 -12 -35 -11 -46 6 -93 16 -44 28 -58 59 -75 35 -18 39 -24 39 -59 0 -35 -4 -41 -39 -59 -31 -17 -43 -31 -59 -75 -17 -47 -18 -58 -6 -93 12 -37 11 -40 -14 -65 -25 -25 -28 -26 -65 -14 -35 12 -46 11 -93 -6 -43 -16 -58 -27 -72 -56 -31 -62 -93 -62 -124 -1 -14 30 -29 41 -72 57 -47 17 -58 18 -93 6 -37 -12 -40 -11 -65 14 -25 25 -26 28 -14 65 12 35 11 46 -6 93 -16 44 -28 58 -59 75 -35 18 -39 24 -39 59 0 35 4 41 39 59 31 17 43 31 59 75 17 47 18 58 6 93 -12 37 -11 40 14 65 25 25 28 26 65 14 35 -12 46 -11 93 6 41 15 58 28 71 53 19 38 34 50 63 50 11 0 26 -4 33 -9z" />
                <path d="M515 751 c-185 -86 -180 -358 9 -436 154 -64 330 54 328 220 -1 135 -102 235 -237 235 -37 0 -75 -7 -100 -19z m211 -36 c135 -79 133 -282 -4 -362 -100 -59 -231 -25 -289 75 -69 117 -9 270 123 312 45 15 122 3 170 -25z" />
            </g>
        </svg>
    )
}